import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ChecklistListEffects } from './checklist-list.effects';
import { initialState, reducer } from './checklist-list.reducer';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { ChecklistListState } from './checklist-list.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';

const syncMetaReducer = createLocalStorageSyncReducer<ChecklistListState>({
  keys: ['selectedChecklistId'],
  rehydrate: true,
  storage: localStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('checklistList', reducer, {
      initialState: initialState,
      metaReducers: [syncMetaReducer],
    }),
    EffectsModule.forFeature([ChecklistListEffects]),
  ],
  providers: [ChecklistListEffects],
})
export class ChecklistListStoreModule {}
